import React, { useEffect } from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles'
// import { amber, deepOrange, grey, indigo, blue, lightBlue } from '@mui/material/colors'
import { grey, blue, purple, orange, green, yellow, red } from '@mui/material/colors'
import { Box } from '@mui/material'

const getDesignTokens = (mode) => ({
    palette: {
        mode,
        primary: {
            ...blue,
            ...(mode === 'light'
                ? {
                    main: '#dddddd99',
                }
                : {
                    main: grey[900],
                }),
        },
        status: {
            created: blue[500],
            inProgress: orange[500],
            resolved: green[500],
            note: purple[500],
            closed: green[700],
            started: orange[700],
            submitted: yellow[700],
            inReview : blue[700],
            awaitingApproval: purple[700],
            approved: green[500],
            issued: green[900],
            rejected: red[700],
            paid: green[500],
            notPaid: red[700],
        },

        ...(mode === 'light'
            ? {
                background: {
                    default:  '#dddddd00',
                    paper: '#ddddddaa',
                    appBar: '#cbd511c2',
                },
            }
            : {
                background: {
                    default: grey[700],
                    paper: grey[900],
                    appBar: '#cbd511c2',
                },
            }),
        text: {
            ...(mode === 'light'
                ? {
                    primary: grey[900],
                    secondary: grey[800],
                }
                : {
                    primary: '#fff',
                    secondary: grey[200],
                }),
        },
        customUploader: {
            ...(mode === 'light'
                ? {
                    border: grey[400],
                    hoverOver: grey[500],
                    hoverOff: grey[300],
                    hoverBorder: grey[600],
                }
                : {
                    border: grey[700],
                    hoverOver: grey[600],
                    hoverOff: grey[800],
                    hoverBorder: grey[200],
                }),
        },
        buttonThatPops: {
            main: purple[200],
            dark: purple[400],
            light: purple[100],
            contrastText: grey[900],
        },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    ...(mode === 'light'
                        ? {
                            '& .MuiPaper-root': {
                                backgroundColor: '#dddddd33',
                            },
                        }
                        : {}),
                },
            },
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    ...(mode === 'light'
                        ? {
                            color: blue[100],
                            backgroundColor: grey[900],
                        }
                        : {
                            color: blue[900],
                            backgroundColor: '#fff',
                        }),
                },
            },
        },
        MuiSnackbarContent: {
            styleOverrides: {
              root: {
                ...(mode === 'dark'
                  ? {
                      backgroundColor: grey[900],
                      color: '#fff',
                    }
                  : {
                      backgroundColor: '#fff',
                      color: grey[900],
                    }),
              },
            },
          },

        MuiStepIcon: {
            styleOverrides: {
                root: {
                    ...(mode === 'light'
                        ? {
                            color: grey[500],

                        }
                        : {
                            color: grey[600],

                        }),
                    '&.Mui-active': {
                        ...(mode === 'light'
                            ? {
                                color: blue[600],

                            }
                            : {
                                color: blue[600],

                            }),
                    },
                    '&.Mui-completed': {
                        color: mode === 'light' ? blue[200] : blue[200],
                    },
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    '&.Mui-checked': {
                        ...(mode === 'light'
                            ? {
                                color: purple[200],
                            }
                            : {
                                color: purple[200],
                            }),
                    },
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    '&.Mui-checked': {
                        ...(mode === 'light'
                            ? {
                                color: purple[200],
                            }
                            : {
                                color: purple[200],
                            }),
                    },
                },
            },
        },
        MuiSwitch: {
            styleOverrides: {
                switchBase: {
                    '&.Mui-checked': {
                        ...(mode === 'light'
                            ? {
                                color: purple[200],
                            }
                            : {
                                color: purple[200],
                            }),
                    },
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        ...(mode === 'light'
                            ? {
                                color: grey[900],
                                backgroundColor: blue[200],
                            }
                            : {
                                color: '#fff',
                                backgroundColor: grey[700],
                            }),
                    },
                },
            },
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    '&.MuiButton-text': {
                        ...(mode === 'light'
                            ? {
                                color: grey[900],
                                backgroundColor: blue[200],
                            }
                            : {
                                color: '#fff',
                                backgroundColor: grey[700],
                            }),
                    },
                },
            },
        },
    },
})

const darkModeTheme = createTheme(getDesignTokens('dark'))
const lightModeTheme = createTheme(getDesignTokens('light'))

const DarkMode = ({ children, mode }) => {
    const [modeTheme, setModeTheme] = React.useState(lightModeTheme)

    useEffect(() => {
        if (mode === 'dark') {
            setModeTheme(darkModeTheme)
            // localStorage.setItem('mode', 'dark')
        } else {
            setModeTheme(lightModeTheme)
            // localStorage.setItem('mode', 'light') 
        }

    }, [mode])

    return (
        <>
            <ThemeProvider theme={modeTheme}>
                <Box sx={{
                    bgcolor: 'background.default',
                    color: 'text.primary'
                }}>
                    {children}
                </Box>
            </ThemeProvider>
        </>
    )
}

export default DarkMode